import {
  configApiRef,
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { appConfigApiRef } from './api/appconfig-api';
import { AppConfigApiClient } from './api/appconfig-api-client';

export const appConfigPlugin = createPlugin({
  id: 'appconfig',
  apis: [
    createApiFactory({
      api: appConfigApiRef,
      deps: { configApi: configApiRef, identityApi: identityApiRef },
      factory: ({ configApi, identityApi }) =>
        new AppConfigApiClient(configApi, identityApi),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const AppConfigPluginPage = appConfigPlugin.provide(
  createRoutableExtension({
    name: 'AppConfigPluginPage',
    component: () => import('./components').then(m => m.AppConfigProfilesCard),
    mountPoint: rootRouteRef,
  }),
);
